module.exports = `...on IdBindLohacoJapanId{
  name
  headerText
  description
  
}
`;
